export const IS_DEVELOPMENT = false;
